import { Box, Button, Divider, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CartItem } from "./CartItem";
import configServ from "../../../services/config";
import { triggerLoader } from "../../../redux/reducers/LoaderTrigger";
import { clear, clearCoupon } from "../../../redux/reducers/Cart";
import { useNavigate } from "react-router-dom";
import AlertDialog from "../../../Components/AlertDialog/AlertDialog";
import Swal from "sweetalert2";
import Calculation from "../../../utility/Calculations";
import PaymentOptionModal from "./PaymentOptionModal";

const Order = () => {
  //#region code
  const { user_id, company_id, currency, companyName } = useSelector(
    (state) => state.GlobalVariables
  );
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("cod");

  const [openModal, setOpenModal] = useState(false);

  const handleOrderClick = async () => {
    try {
      const success = await fetchConfig();
      if (success) {
        setOpenModal(true); // Open only after successful config fetch
      }
    } catch (error) {
      console.error("Error handling order click:", error);
    }
  };

  const handleOpenDialog = (content) => {
    setDialogContent(content);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogContent("");
  };
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const navigate = useNavigate();
  // console.log("cart=", cart);

  const getCurrentDate = () => {
    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const year = currentDate.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const generateOrderNumber = () => {
    const min = 100000;
    const max = 999999;
    const number = Math.floor(Math.random() * (max - min + 1)) + min;
    return `ORD${number}`;
  };

  const fetchUserName = async () => {
    const id = {
      user_id: user_id,
    };
    if (id.user_id !== undefined) {
      // const res = await http.post('/api/profiledetail',id )
      const res = await configServ.profiledetail(id);
      if (res.success) {
        return res.success.name;
      } else {
        console.log("Error while fetchiing user data");
      }
    } else {
    }
  };

  const itemAssign = async () => {
    try {
      const selectedItemsArray = cart.cartValue.map((item) => ({
        company_id: company_id,
        itemname: item.itemname,
        hsn_code: item.hsn_code,
        Taxrate: item.Taxrate,
        discount: item.discount,
        qty: item.qty,
        rate: item.rate,
        tax_amount:
          item.qty *
          Calculation.taxAmount(item.rate, item.discount, item.Taxrate),
        amount:
          item.qty *
          Calculation.netAmount(item.rate, item.discount, item.Taxrate),
        itemid: item.id,
        item_code: item.item_code,
        size_id: item.size_id,
        issizeAdded: item.issizeAdded,
        item_size: item.item_size,
      }));

      return selectedItemsArray;
    } catch (e) {
      console.log(e);
    }
  };

  const [showgateway, setShowgateway] = useState(false);
  const fetchConfig = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
      };
      const res = await configServ.getConfiguration(dataToSend);
      if (res.status === 200) {
        const result = res.data;
        setShowgateway(result.is_gateway_enable ?? false);
        return true;
      } else {
        console.log(res.message);
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    } finally {
    }
  };
  // useEffect(() => {
  //   fetchConfig();
  // }, []);

  const handleOrder = async (e) => {
    if (e) e.preventDefault();
    dispatch(triggerLoader());
    const dataToSend = {
      order_no: generateOrderNumber(),
      customer_id: user_id,
      company_id: company_id,
      order_date: getCurrentDate(),
      partyname: await fetchUserName(),
      shiptoaddress: cart.shiptoaddress,
      billtoaddress: cart.billtoaddress,
      with_gst: 1,
      currency: currency,
      tax_amount: cart.cartTaxAmount,
      total_amount: cart.cartNetAmount,
      item: [],
      is_coupon_applied: true,
      coupon_code: cart?.selectedCoupons[0]?.code,
      coupon_discount: cart?.couponDiscount,
      coupon_id: cart?.selectedCoupons[0]?.id,
    };
    dataToSend.item = await itemAssign();
    try {
      const res = await configServ.placeOrder(dataToSend);
      if (res.status === 200) {
        Swal.fire({
          title: "Order!",
          text: "Your order is successfully placed!",
          icon: "success",
        });

        navigate("/Purchase-Order");
        dispatch(clear());
        dispatch(clearCoupon());
      } else {
        Swal.fire({
          icon: "error",
          title: "Order!",
          text: "Failed to place order. Something went wrong!",
        });
      }
    } catch (e) {
      console.log(e);
      Swal.fire({
        icon: "error",
        title: "Order!",
        text: "Failed to place order. Something went wrong!",
      });
    } finally {
      dispatch(triggerLoader());
    }
  };

  const handleOnlinePayment = async () => {
    try {
      // ✅ Step 1: Get active payment gateway from backend
      const gatewayRes = await configServ.getActiveGateway({
        company_id: company_id,
      });

      const activeGateway = gatewayRes?.data;

      if (!activeGateway) {
        Swal.fire({
          icon: "error",
          title: "Gateway Error!",
          text: "❌ No active payment gateway found.",
        });
        return;
      }

      // ✅ Step 2: Check if it's Razorpay
      if (activeGateway.getway_name === "razorpay") {
        const dataToSend = {
          amount: cart.cartNetAmount,
          company_id: company_id,
          user_id: user_id,
        };

        const res = await configServ.createOrderRazorpay(dataToSend);

        const data = res.data;

        const options = {
          key: data.key,
          amount: data.amount,
          currency: data.currency,
          name: companyName, // ❗ remove curly braces around companyName
          description: "Subscription Payment",
          order_id: data.order_id,
          handler: async function (response) {
            const dataToSend = {
              order_no: generateOrderNumber(),
              customer_id: user_id,
              company_id: company_id,
              order_date: getCurrentDate(),
              partyname: await fetchUserName(),
              shiptoaddress: cart.shiptoaddress,
              billtoaddress: cart.billtoaddress,
              with_gst: 1,
              currency: currency,
              tax_amount: cart.cartTaxAmount,
              total_amount: cart.cartNetAmount,
              item: [],
              is_coupon_applied: true,
              coupon_code: cart?.selectedCoupons[0]?.code,
              coupon_discount: cart?.couponDiscount,
              coupon_id: cart?.selectedCoupons[0]?.id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              amount: data.amount,
              log_id: data.log_id,
            };
            dataToSend.item = await itemAssign();
            try {
              const verifyRes = await configServ.verifyPayment(dataToSend);

              if (verifyRes.status === "success") {
                Swal.fire({
                  title: "Success!",
                  text: "Your order has been successfully placed.",
                  icon: "success",
                });
                navigate("/Purchase-Order");
                dispatch(clear());
                dispatch(clearCoupon());
              } else {
                Swal.fire({
                  title: "Failed!",
                  text: "Failed to verify payment.",
                  icon: "error",
                });
              }
            } catch (verifyError) {
              Swal.fire({
                title: "Verification Error!",
                text: "Could not verify payment. Try again.",
                icon: "error",
              });
            }
          },
          prefill: {
            name: "krishna kumar", // You can fetch from user profile
            email: "test@example.com",
            contact: "8540862394",
          },
          theme: {
            color: "#3399cc",
          },
        };

        const rzp = new window.Razorpay(options);

        // ✅ Step 3: Handle failure event
        rzp.on("payment.failed", function (response) {
          console.log("Payment Failed:", response);

          configServ.updateFailedPayment({
            log_id: data.log_id,
            response: response.error, // contains full error object
          });

          Swal.fire({
            icon: "error",
            title: "Payment Failed!",
            text:
              response.error.description ||
              "Transaction was not completed. Please try again.",
          });
        });

        rzp.open();
      } else {
        // ✅ Step 4: Unsupported gateway
        const friendlyLabel = {
          paypal: "PayPal",
          stripe: "Stripe",
          phonepe: "PhonePe",
          cashfree: "Cashfree",
        };

        const label =
          friendlyLabel[activeGateway.getway_name] || activeGateway.getway_name;

        Swal.fire({
          icon: "info",
          title: "Coming Soon!",
          text: `${label} integration is under development.`,
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      console.error("Payment Error:", error);

      Swal.fire({
        icon: "error",
        title: "Payment Error!",
        text: "Something went wrong while initiating payment.",
        confirmButtonText: "Okay",
      });
    }
  };

  const handlePaymentConfirm = (method) => {
    console.log("Selected Payment Method:", method);
    // 👉 based on method, call your APIs or trigger logic
    if (method === "cod") {
      handleOrder();
    } else {
      handleOnlinePayment(); // redirect or show online payment
    }
  };

  //#endregion

  return (
    <>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title="Alert"
        message={dialogContent}
        buttonTitle="Ok"
      />
      <Grid
        container
        alignItems={"center"}
        justifyContent={"center"}
        spacing={1}
      >
        <Grid
          container
          xs={12}
          md={6}
          alignItems={"center"}
          spacing={1}
          p={3}
          sx={{ background: "#fffff5" }}
          border="1px solid #33333355"
        >
          <Grid container item xs={12} justifyContent={"center"}>
            <Typography variant="h6">
              <b>ORDER CONFIRMATION</b>
            </Typography>
          </Grid>
          <br />
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body">Bill to address</Typography>
              <Typography variant="body2" fontWeight="bold" color="text">
                {cart.billtoaddress}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body">Ship to address</Typography>
              <Typography variant="body2" fontWeight="bold" color="text">
                {cart.shiptoaddress}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body" fontWeight="bold">
              Product(s)
            </Typography>
          </Grid>
          {/* <Divider sx={{ bgcolor: '#999', width: '100%' }} /> */}
          {cart.cartValue.map((item) => (
            <Grid key={item.id} item xs={12}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="body">
                  {item.itemname}{" "}
                  <span style={{ fontWeight: "bold", marginLeft: "10px" }}>
                    x {item.qty}
                  </span>
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {Calculation.netAmount(
                    item.rate,
                    item.discount,
                    item.Taxrate
                  )}
                </Typography>
              </Box>
            </Grid>
          ))}
          <br />
          <Divider sx={{ bgcolor: "#999", width: "100%" }} />
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body">Coupon Discount</Typography>
              <Typography variant="body2" fontWeight="bold" color="text">
                {currency} {cart?.couponDiscount}
              </Typography>
            </Box>
          </Grid>
          <br />
          <Divider sx={{ bgcolor: "#999", width: "100%" }} />
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body">Total Amount</Typography>
              <Typography variant="body2" fontWeight="bold" color="text">
                {currency} {cart.cartNetAmount}
              </Typography>
            </Box>
          </Grid>
          <Divider sx={{ bgcolor: "#999", width: "100%" }} />
          <br />
          <Grid container item xs={12} justifyContent={"center"}>
            <Button
              variant="contained"
              color="success"
              onClick={handleOrderClick}
              sx={{
                mt: 3,
                mb: 2,
                width: "200px",
                minWidth: "200px",
                ":hover": {
                  backgroundColor: "black",
                },
                alignSelf: {
                  xs: "center",
                  md: "flex-start",
                },
              }}
            >
              Placed Order
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <PaymentOptionModal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setPaymentMethod("cod"); // reset on modal close
        }}
        onConfirm={handlePaymentConfirm}
        setPaymentMethod={setPaymentMethod}
        paymentMethod={paymentMethod}
        showgateway={showgateway}
      />
    </>
  );
};
export default Order;
